"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const themes_1 = require("@/theme/themes");
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Loading_1 = require("../layout/Loading");
const format_1 = require("@/utils/format");
const Amount_1 = __importDefault(require("../layout/Amount"));
const Amount_2 = require("../layout/Amount");
const react_2 = require("@connect2ic/react");
const config = {
    baseRate: 5,
    step: 1,
    min: 1,
    max: 5,
    steps: {
        1: 1,
        2: 1.15,
        3: 1.4,
        4: 1.65,
        5: 2,
    },
};
const CustomSlider = ({ col, isPageLoading, color }) => {
    const [value, setValue] = (0, react_1.useState)(1);
    const [rate, setRate] = (0, react_1.useState)(5);
    const [total, setTotal] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [currentRewardRate, setCurrentRewardRate] = (0, react_1.useState)(0);
    const [rates, setRates] = (0, react_1.useState)([]);
    const [ratesSum, setRatesSum] = (0, react_1.useState)([]);
    const [metrics, setMetrics] = (0, react_1.useState)();
    const [governanceActor] = (0, react_2.useCanister)('governance', { mode: 'connected' });
    const onChange = (e) => {
        setValue(e.target.value);
    };
    const getData = async () => {
        const metrics = await governanceActor.get_metrics();
        const totalStaked = [
            Number(metrics.locked_tier_1) / 10e7,
            Number(metrics.locked_tier_2) / 10e7,
            Number(metrics.locked_tier_3) / 10e7,
            Number(metrics.locked_tier_4) / 10e7,
            Number(metrics.locked_tier_5) / 10e7
        ];
        setRates(totalStaked);
        setRatesSum([
            totalStaked[0] + totalStaked[1] + totalStaked[2] + totalStaked[3] + totalStaked[4],
            totalStaked[1] + totalStaked[2] + totalStaked[3] + totalStaked[4],
            totalStaked[2] + totalStaked[3] + totalStaked[4],
            totalStaked[3] + totalStaked[4],
            totalStaked[4],
        ]);
        const totalLocked = Number(metrics.locked_tier_1) * config.steps[1]
            + Number(metrics.locked_tier_2) * config.steps[2]
            + Number(metrics.locked_tier_3) * config.steps[3]
            + Number(metrics.locked_tier_4) * config.steps[4]
            + Number(metrics.locked_tier_5) * config.steps[5];
        setCurrentRewardRate((Number(metrics.current_epic_rewards)) / (Number(totalLocked)));
        //setCurrentRewardRate(0.05);
        setMetrics(metrics);
        setLoading(false);
    };
    (0, react_1.useEffect)(() => {
        setRate(Math.round(((config.steps[value] * (currentRewardRate ? currentRewardRate * 100 : 0)) + Number.EPSILON) * 100) / 100);
    }, [value, metrics?.reward_rate]);
    (0, react_1.useEffect)(() => {
        getData();
    }, []);
    if (!isPageLoading) {
        return (react_1.default.createElement(SliderContainer, { sx: { gridColumn: col ? `span ${col}` : '' }, color: color },
            react_1.default.createElement(Amount_1.default, { size: Amount_2.AmountSize.Big, amount: rate.toLocaleString(), token: "%" }),
            react_1.default.createElement(material_1.Slider, { onChange: onChange, "aria-label": "Reward rate", defaultValue: 1, valueLabelDisplay: "auto", step: config.step, marks: true, min: config.min, max: config.max, sx: {
                    height: 15,
                    '& .MuiSlider-track': {
                        background: 'linear-gradient(153deg, rgba(10,181,127,1) 0%, rgba(248,176,115,1) 100%)',
                    },
                    '& .MuiSlider-rail': {
                        backgroundColor: `#86858A`,
                    },
                    '& .MuiSlider-thumb': {
                        width: 25,
                        height: 25,
                        backgroundColor: themes_1.darkTheme.colors.charts[0],
                        border: '5px solid #fff',
                    },
                } }),
            react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'space-between', color: 'inherit' } },
                react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexDirection: 'column', color: 'inherit' } },
                    loading && (react_1.default.createElement(material_1.Box, { style: {
                            marginBottom: '30px',
                        } },
                        react_1.default.createElement(Loading_1.Loading, null))),
                    react_1.default.createElement(material_1.Box, { sx: { display: 'flex', gap: 8, justifyContent: "space-between", width: "100%" } },
                        value !== 5 && (react_1.default.createElement("div", { style: { fontSize: 22 } },
                            !loading && (react_1.default.createElement(Amount_1.default, { size: Amount_2.AmountSize.Small, amount: (0, format_1.formatAmount)(ratesSum[value - 1]) })),
                            react_1.default.createElement(material_1.Box, { sx: { color: 'inherit', fontSize: 14 } },
                                "currently locked for at least ",
                                value,
                                " ",
                                value === 1 ? "year" : "years"))),
                        react_1.default.createElement("div", { style: { fontSize: 22 } },
                            !loading && (react_1.default.createElement(Amount_1.default, { size: Amount_2.AmountSize.Small, amount: (0, format_1.formatAmount)(rates[value - 1]) })),
                            react_1.default.createElement(material_1.Box, { sx: { color: 'inherit', fontSize: 14 } },
                                "currently locked for ",
                                value,
                                " ",
                                value === 1 ? "year" : "years")))))));
    }
};
exports.default = CustomSlider;
const ChartContainer = (0, styled_components_1.default)('div') `
  grid-column: span 12;
  background-color: ${(props) => props.theme.colors.chartsBg};
  border-radius: ${(props) => props.theme.radius.md};
`;
const ChartLoading = (0, styled_components_1.default)('div') `
  height: 400px;
`;
const SliderContainer = (0, styled_components_1.default)(material_1.Box) `
  color: ${(props) => props.theme.colors[props.color]};
  width: 100%;
`;
